"use strict";

import Swiper from "swiper";
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';
import "swiper/css";

const swipers = document.querySelectorAll(
    ".wp-block-pulp-image-carousel .swiper"
);

swipers.forEach((el, index) => {
    const swiper = new Swiper(el, {
        modules: [Autoplay, FreeMode, Navigation],
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 4000,
        },
        // autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
        // speed: 3000,
        // autoplay: {
        //     delay: 0 // this prevent pauseOnMouseHover from working
        // },
        // freeMode: {
        //     enabled: true
        // }
    });

    swiper.on('slideChange', function () {
        $(el).find('.swiper-counter .current-slide').text(swiper.realIndex + 1);
    });
});

if($('.image-carousel-groups').length > 0) {
    $('.image-carousel-groups').each(function() {

        let block = $(this),
            quickLinks = block.find('.quick-links-container .quick-links button'),
            quickLinksMobileToggle = block.find('.quick-links-dropdown-toggle'),
            quickLinksMobileContainer = block.find('.quick-links'),
            carouselsContainer = block.find('.carousels-container'),
            carousels = block.find('.carousels-container .image-carousel-container');

        quickLinksMobileToggle.on('click', function() {
            $(this).toggleClass('is-open');
            quickLinksMobileContainer.slideToggle();
        });

        quickLinks.on('click', function() {
            let index = $(this).index();
            quickLinks.removeClass('active');
            $(this).addClass('active');

            if(window.innerWidth < 992) {
                quickLinksMobileToggle.find('.quick-links-display-label').text($(this).text());
                quickLinksMobileToggle.removeClass('is-open');
                quickLinksMobileContainer.slideUp();
            }

            carouselsContainer.height(carouselsContainer.outerHeight());
            carousels.removeClass('showing');
            setTimeout(() => {
                carousels.not(carousels.eq(index)).removeClass('active');
                carousels.eq(index).addClass('active');
            }, 505);

            setTimeout(() => {
                carousels.eq(index).addClass('showing');
            }, 510);

            // remove height after transition
            setTimeout(() => {
                carouselsContainer.height('auto');
            }, 1000);
        });

    });
}
